import styled from 'styled-components';
import { HeaderTextView } from '../styles/TextStyles'


const ParentView = styled.div`
    display:flex;
    align-content:center;
    position:fixed;
    top:20%;
    left:15%;
    bottom:0;
    right:15%;
    bottom:20%;
    align-items:center;
    justify-content:center;
`;

export default function EmptyView() {
    return <ParentView>
        <HeaderTextView>No More Profiles</HeaderTextView>
    </ParentView>
}